const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/crm/contacts/contact/$contactId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireUserPostCaps } from '@/Router';
import { ContactSingleQuery, type Contact_Single_Query, type Contact_Single_Query$data } from '@/graphql/queries/Contact.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { createFileRoute } from '@tanstack/react-router';
import { type Control } from 'react-hook-form';
import { loadQuery } from 'react-relay';
export const Route = createFileRoute('/dash/crm/contacts/contact/$contactId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  beforeLoad: () => {
    requireUserPostCaps('contact', 'edit_post', {
      to: '/dash/crm/contacts'
    });
  },
  loader: match => {
    return loadQuery<Contact_Single_Query>(RelayEnvironment, ContactSingleQuery, {
      contactId: match.params.contactId
    }, {
      fetchPolicy: 'store-or-network'
    });
  }
});
type RightPanelProps = {
  control: Control<ContactFormData>;
  data?: Contact_Single_Query$data;
  fallback?: boolean;
};

/**
 * Load what integrations are available and render the appropriate components
 */